import { render } from "./LandingRefugios.vue?vue&type=template&id=65e1ae2e"
import script from "./LandingRefugios.vue?vue&type=script&lang=js"
export * from "./LandingRefugios.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__